import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {BodyMetricId} from '../../domain/body-metric-id.value-object';

/** Route-param guard for `$bodyMetricId`; mirrors the server's `bmt_` prefix. */
export class BodyMetricIdValidator implements Validator<BodyMetricId> {
  readonly standardSchema = z.templateLiteral(['bmt', '_', z.string().min(1)]);

  validate(value: unknown): Result<BodyMetricId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid metric id.'));
    }
    return ok(parsed.data);
  }
}
